import React, { useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { submitForm } from './submitForm'; // Import the submitForm function

function Contact() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [status, setStatus] = useState('');
  const recaptchaRef = React.createRef();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // Execute the reCAPTCHA v3 and get the token
      const token = await recaptchaRef.current.executeAsync();

      // Check if the token was successfully received
      if (!token) {
        setStatus('CAPTCHA validation failed');
        return;
      }

      // Call the submitForm function with the form data and the token
      const result = await submitForm({ name, email, message, token });
      setStatus(result.message);

      if (result.success) {
        setName('');
        setEmail('');
        setMessage('');
      }
    } catch (error) {
      setStatus('Error occurred when sending message: ' + error.message);
    }

    // Reset reCAPTCHA
    recaptchaRef.current.reset();
  };

  return (
    <section className="section">
      <div className="container">
        <h2 className="title">Contact Me</h2>
        <form onSubmit={handleSubmit}>
          <div className="field">
            <label className="label">Name</label>
            <div className="control">
              <input
                className="input"
                type="text"
                placeholder="Your Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>
          </div>
          <div className="field">
            <label className="label">Email</label>
            <div className="control">
              <input
                className="input"
                type="email"
                placeholder="Your Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
          </div>
          <div className="field">
            <label className="label">Message</label>
            <div className="control">
              <textarea
                className="textarea"
                placeholder="Your Message"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                required
              ></textarea>
            </div>
          </div>
          <ReCAPTCHA
            ref={recaptchaRef}
            sitekey="6Ldo0SoqAAAAANWaV9tulb0ZCk-O6X7HH-UMaf5W"
            size="invisible"
          />
          <div className="field">
            <div className="control">
              <button className="button is-link" type="submit">Send Raven</button>
            </div>
          </div>
          {status && <p>{status}</p>}
        </form>
      </div>
    </section>
  );
}

export default Contact;
